import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailNotificationComponent } from '../../components/email-notification/email-notification.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunEachDirective } from '../../directives/email-mailgun-each.directive';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import type { WrappedValue } from '../../mailgun/wrap-value';
import { MailgunMarkAsHtmlPipe } from '../../pipes/mailgun-mark-as-html.pipe';

@Component({
  selector: 'email-multiple-notifications-template',
  styleUrls: ['../../global-styles.less'],
  templateUrl: './multiple-notifications.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailNotificationComponent,
    MailgunMarkAsHtmlPipe,
    EmailMailgunEachDirective,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class MultipleNotificationsTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<MultipleNotificationsTemplateData>;
}

export type MultipleNotificationsTemplateData = {
  title: string;
  p1: string;
  avatar_url?: string;
  notifications: Array<{
    avatar_url: string;
    html: string;
  }>;
  total?: number;
  button_link: string;
  button_text: string;
  footer_p1: string;
  footer_link: string;
  footer_link_text: string;
};

export const MultipleNotificationsTemplateMocks: MultipleNotificationsTemplateData[] = [
  {
    title: '23 notifications',
    p1: 'You have unread notifications in ACME.',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    total: 10,
    notifications: [
      {
        avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
        html: '<b>Olivia Novak</b> added a Team Note to candidate <a href="#"><b>Bruce Davos</b></a>.',
      },
      {
        avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
        html: '<b>Amy Loes</b> added you as a follower of a candidate <a href="#"><b>Josh Newman</b></a>.',
      },
      {
        avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
        html: 'Olivia Novak added a Team Note to candidate Bruce Davos.',
      },
    ],
    button_link: 'http://recruitee.com',
    button_text: 'View all 23 notifications',
    footer_p1: 'This email was sent by Recruitee.com',
    footer_link: 'http://recruitee.com',
    footer_link_text: 'Change your notification settings',
  },
];
